import styled from '@emotion/styled';
import { ComponentPropsWithRef } from 'react';
import rem from '../../utils/rem/rem';
import { StyledInput } from '../Input/Input.styles';

type StyledProps = {
  resizable: boolean;
  width?: number;
};

export const TextAreaWrapper = styled.div`
  border-radius: ${rem(8)};
  position: relative;
  overflow: hidden;
  width: min-content;
`;
const InputAsTextarea = StyledInput.withComponent('textarea'); // this extra step is required for type conversion
// the width prop is not testable in jsdom
/* istanbul ignore next */
export const StyledTextarea = styled(InputAsTextarea)<StyledProps & ComponentPropsWithRef<'textarea'>>`
  resize: ${({ resizable }) => !resizable && 'none'};
  min-height: ${rem(40)};
  box-sizing: border-box;
  width: ${({ width }) => (width ? `${width}px` : '')};

  &::-webkit-resizer {
    display: none;
  }
`;

export const IconWrapper = styled.div<StyledProps>`
  display: ${({ resizable }) => (resizable ? 'block' : 'none')};
  position: absolute;
  bottom: ${rem(10)};
  right: ${rem(4)};
  pointer-events: none;
  font-size: ${rem(12)};
`;
